import { CheckCircle } from 'lucide-react';
import type { PlanCatalogItem } from '@practium/features/api';
import {
	formatPlanPrice,
	getAudienceLabel,
	isFeaturedCatalogPlan,
} from '../../utils/formatMyPlan';
import styles from './CatalogPlanCard.module.css';

type CatalogPlanAction = 'current' | 'upgrade' | 'downgrade';

interface CatalogPlanCardProps {
	plan: PlanCatalogItem;
	action: CatalogPlanAction;
	onSelect: () => void;
}

export const CatalogPlanCard = ({ plan, action, onSelect }: CatalogPlanCardProps) => {
	const featured = isFeaturedCatalogPlan(plan.name, plan.hierarchy?.role);
	const intervalRate = plan.interval === 'year' ? 'ano' : 'mês';
	const billedLabel = plan.interval === 'year' ? 'Cobrado anualmente' : 'Cobrado mensalmente';
	const buttonLabel =
		action === 'current'
			? 'Plano em uso'
			: action === 'upgrade'
				? 'Fazer upgrade'
				: `Mudar para ${plan.name}`;

	return (
		<article className={`${styles.card} ${featured ? styles.featured : ''}`}>
			{featured ? <span className={styles.badge}>Mais escolhido</span> : null}
			<span className={styles.audience}>
				{getAudienceLabel(plan.hierarchy?.role, plan.name)}
			</span>
			<h4 className={styles.name}>{plan.name}</h4>
			<p className={styles.description}>{plan.description || '—'}</p>
			<div className={styles.priceRow}>
				<span className={styles.price}>R$ {formatPlanPrice(plan.price)}</span>
				<span className={styles.interval}>/{intervalRate}</span>
			</div>
			<span className={styles.billed}>{billedLabel}</span>
			<ul className={styles.advantages}>
				{plan.advantages.map((advantage) => (
					<li key={advantage} className={styles.advantage}>
						<CheckCircle className={styles.check} strokeWidth={2.4} />
						<span>{advantage}</span>
					</li>
				))}
			</ul>
			<button
				type="button"
				className={`${styles.button} ${styles[action]}`}
				disabled={action === 'current'}
				onClick={onSelect}
			>
				{buttonLabel}
			</button>
		</article>
	);
};
